import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createAgentAutoRoutingApi } from '.';
export var createAgentAutoRoutingApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAgentAutoRoutingApi('', fakeHttp);
    var agentsAutoRoutingRelativePath = '/agents/autoRouting';
    var testKit = {
        whenGetAutoRoutingState: function () {
            return createFakeGetResponder(fakeHttp, agentsAutoRoutingRelativePath);
        },
        whenEnableFeature: function (dto) {
            return createFakePostResponder(fakeHttp, agentsAutoRoutingRelativePath + "/settings/feature/enable")(dto);
        },
        whenDisableFeature: function (dto) {
            return createFakePostResponder(fakeHttp, agentsAutoRoutingRelativePath + "/settings/feature/disable")(dto);
        },
        whenDecline: function (dto) {
            return createFakePostResponder(fakeHttp, agentsAutoRoutingRelativePath + "/decline")(dto);
        },
        whenGetPendingAssignment: function () {
            return createFakeGetResponder(fakeHttp, agentsAutoRoutingRelativePath + "/pendingAssignment");
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map